import styled from 'styled-components';
const ButtonLink = styled.div`
    padding: 0.5rem 1rem;
    background: #000;
    color: #fff;
    border-radius: 0.5rem;
    cursor: pointer;
`
export default ButtonLink;